import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query"

import { LanguageContext } from "../i18n/LanguageProvider"
import { fetchCvs } from "../services/utils/fetch"

const POLLING_TIME = 10_000 // 10 seconds in ms

export const useFetchCVs = ({ userId, enableRefetch, callback, refetchOnMount, limit, offset }) => {
  const dispatch = useDispatch();
  const { language } = useContext(LanguageContext);

  return useQuery({
    queryKey: ['cvs', userId, language, limit, offset],
    queryFn: () => fetchCvs(dispatch, callback, limit, offset),
    refetchInterval: enableRefetch && POLLING_TIME,
    staleTime: POLLING_TIME,
    refetchOnMount,
    refetchOnWindowFocus: enableRefetch,
  });
}
